/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import RouterLink from 'app/common/components/singlespa/router-link';
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import { isNavigating } from 'app/gamma/src/selectors/ui';
import HeaderBrandingLogo from './header-branding-logo';
import styles from './header.less';

interface StateProps {
  brandingLogo: string | undefined;
  isNavigating: boolean;
}

interface Props extends StateProps {
  className?: string;
  preventDefault?: boolean;
}

class HeaderLogo extends React.Component<Props> {
  render() {
    const classes = classNames(
      styles.logo,
      this.props.className,
      this.props.isNavigating && styles.throbbing,
      this.props.brandingLogo && styles.branded,
    );

    return (
      <RouterLink
        href="/"
        className={classes}
        preventDefault={this.props.preventDefault}
      >
        <HeaderBrandingLogo />
        <span className={styles.loadingLogo} />
        <span className={styles.defaultLogo} />
      </RouterLink>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    brandingLogo: state.ui.header.brandingLogo,
    isNavigating: isNavigating(state),
  };
}

export default connect(mapStateToProps)(HeaderLogo);
